import React from 'react';
import Currency from 'react-currency-formatter';
import AccessoriesControlBar from './AccessoriesControlBar';

const AccessoriesListControl = ({
  item,
  index,
  deleteItem,
  duplicateItem,
  changePosition,
  checkPossibility,
  wardrobe,
}) => {
  // const actualPrice = item.calculateActualPrice ?? item.price.actual;

  return (
    <div className="accessories-control" title={item.safo}>
      <div className="accessories-control__box">
        <img className="accessories-control__img" src={item.icon} alt={item.name} />
        <div>
          <span className="accessories-control__item">{item.name}</span>
          <div className="flex">
            <span className="accessories-control__item accessories-control__item--price">
              {item.gratis ? (
                <span>GRATIS</span>
              ) : (
                <Currency quantity={item.price.actual} currency="PLN" />
              )}
            </span>
            {item.price.actual < item.price.regular && (
              <span className="accessories-control__item accessories-control__item--old-price">
                <del>
                  <Currency quantity={item.price.regular} currency="PLN" />
                </del>
              </span>
            )}
          </div>
        </div>
      </div>
      <AccessoriesControlBar
        item={item}
        index={index}
        wardrobe={wardrobe}
        deleteItem={deleteItem}
        duplicateItem={duplicateItem}
        changePosition={changePosition}
        checkPossibility={checkPossibility}
      />
    </div>
  );
};

export default AccessoriesListControl;
